import { Suspense } from "react";

import { MapPanel } from "~/modules/map/components/MapPanel";
import { ObservationCardFragment } from "~/modules/mapEditor/components/ObservationCard/fragments.generated";

import { MapEditorEcologicalFunctionPanelSkeleton } from "./components/MapEditorEcologicalFunctionPanelSkeleton";
import { MapEditorEcologicalFunctionPanelEditable } from "./MapEditorEcologicalFunctionPanelEditable";
import { MapEditorEcologicalFunctionPanelReadOnly } from "./MapEditorEcologicalFunctionPanelReadOnly";

export interface MapEditorEcologicalFunctionPanelProps {
    backHref: string;
    createHrefToObservation: (element: ObservationCardFragment) => string;
    mapEditorFeatureId: string;
    onEcologicalFunctionDeleted?: () => Promise<void> | void;
    readonly: boolean;
    title: string;
}

export function MapEditorEcologicalFunctionPanel({
    backHref,
    createHrefToObservation,
    mapEditorFeatureId,
    onEcologicalFunctionDeleted,
    readonly,
    title,
}: MapEditorEcologicalFunctionPanelProps) {
    return (
        <MapPanel>
            <Suspense key={mapEditorFeatureId} fallback={<MapEditorEcologicalFunctionPanelSkeleton />}>
                {readonly ? (
                    <MapEditorEcologicalFunctionPanelReadOnly
                        backHref={backHref}
                        mapEditorFeatureId={mapEditorFeatureId}
                        title={title}
                    />
                ) : (
                    <MapEditorEcologicalFunctionPanelEditable
                        backHref={backHref}
                        createHrefToObservation={createHrefToObservation}
                        mapEditorFeatureId={mapEditorFeatureId}
                        onEcologicalFunctionDeleted={onEcologicalFunctionDeleted}
                        title={title}
                    />
                )}
            </Suspense>
        </MapPanel>
    );
}
